import "./../login/login.css";
import "./otp.css";
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Card } from "react-bootstrap/";
import Logo from "./../../assets/logo.svg";
import { TextField, Button } from "@mui/material";
import { TailSpin } from "react-loader-spinner";
import axios from "../../network/api";
import { baseUrl } from "../../network/constants/constants";
import AppConstants from "../AppConstants"; 

function Otp() {
  const location = useLocation();
  const phone = location.state?.data?.phone;
  const [otp, setOTP] = useState("");
  const [loading, setLoading] = useState(false);
  const [otpError, setOtpError] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!phone) {
      navigate("/login", { replace: true });
    }
  }, [phone, navigate]);

  const handleOTP = (event) => {
    setOTP(event.target.value);
  };

  const validateOTP = (otp) => {
    const regex = /^\d{6}$/;
    setOtpError(!regex.test(otp));
    return regex.test(otp);
  };

  const PostOTP = () => {
    console.log("PostOTP called");
    setLoading(true);

    const payload = {
      phone: phone,
      otp: otp,
    };

    axios
      .post(baseUrl + "auth/auth/business-validate/", payload)
      .then((response) => {
        console.log("API Response:", response.data);
        setLoading(false);
        const token = response.data["token"];

        if (token) {
          console.log("Token received, setting localStorage...");

          localStorage.setItem(AppConstants.JWT, response.data["token"]);
          localStorage.setItem("isLoggedIn", "true");
          localStorage.setItem(
            AppConstants.business_title,
            response.data["business_details"]["business_title"]
          );
          localStorage.setItem(
            AppConstants.business_id,
            response.data["business_details"]["id"]
          );
          localStorage.setItem("isOtpVerified", "true"); 

          window.dispatchEvent(new Event('authChange'));
          console.log("About to navigate to /home using navigate()");

          navigate("/home", { replace: true });
          
        } else {
          console.log("No token received, navigating to login");
          navigate("/login", { replace: true });
        }
      })
      .catch((error) => {
        console.log("API Error:", error);
        
        if (error.response?.status === 403) {
          alert("Invalid OTP or OTP expired. Please try again.");
          setOtpError(true);
        } else {
          alert("You have no Permission. Please try again.");
        }

        setLoading(false);
      });
  };

  if (!phone) return null; 

  return (
    <section id="login">
      <div className="content">
        <div className="brand-container">
          <img src={Logo} className="logo" alt="Logo" />
          <div className="business-name">Onescribe Business Panel</div>
        </div>
        <Card className="login-card card mt-5 rounded-4">
          <div className="login-title">OTP Verification</div>

          <TextField
            id="otp"
            className="mt-4"
            label="Enter OTP"
            variant="outlined"
            size="small"
            value={otp}
            onChange={handleOTP}
            error={otpError}
            helperText={otpError ? "Invalid OTP Number" : ""}
          />

          <Button
            variant="contained"
            className="login-btn mt-5 mb-3"
            onClick={() => {
              if (validateOTP(otp)) {
                PostOTP();
              }
            }}
            disabled={loading}
          >
            Submit
          </Button>
          <div className="not-number">
            {phone}
            <div onClick={() => navigate("/login", { replace: true })}>
              Not your Number? Click to Go Back
            </div>
          </div>
          <div className="spiner-container">
            <TailSpin
              className="mt-5"
              height="30"
              width="30"
              radius="1"
              color="#ffbe00"
              ariaLabel="loading"
              visible={loading}
            />
          </div>
        </Card>
      </div>

      <a href="tel:+919481815122" className="contact">
        ⓘ Contact Us
      </a>
    </section>
  );
}

export default Otp;